<template>
<el-card shadow="never" style="width:600px;">
    <div v-if="loading" class="loading-container">
        <i class="el-icon-loading"></i>
        Connecting to Quickbooks...
    </div>

    <div v-else>
        <el-alert effect="dark" title="Warning" type="warning" description="Please sign-in to Quickbooks first before you can use this page." show-icon :closable="false"></el-alert>
        <el-button style="margin-top:10px" type="primary" @click="handleAuthLink">Sign-in</el-button>
    </div>
</el-card>
</template>

<script>
export default {
    props: {
        handleAuthLink: {
            type: Function
        },
        loading: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.loading-container {
    padding: 30px;
    text-align: center;
}
</style>
